import React from 'react';
import { connect } from 'react-redux';

import { REDUCER_NAME, deleteAllowance } from 'src/reducers/clients/allowances';
import {
  CLIENT_ALLOWANCE_NEW,
  CLIENT_UNIT_PRICES_LIST,
  CLIENT_SETTINGS,
  CLIENT_PAYROLL_RULES_GROUP_LIST,
  CLIENT_ALLOWANCE_CHANGE_DISPLAY_ORDERS
} from 'src/constants/EndpointUrls';
import Tag from 'jbc-front/components/Tag';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import ActionButton from 'jbc-front/components/ActionButton';
import { Plus, Drugging } from 'jbc-front/components/icons';
import { concatParamsToUrl } from 'src/utils/Http';
import { getList } from 'src/reducers/common/listReducer';
import { setGlobalErrors, setGlobalSuccesses } from 'src/reducers/global';
import { getRadioOptions } from 'src/reducers/selectOptions';
import { withTranslation } from 'react-i18next';

import AllowancesTable from '../containers/AllowancesTable';
import styles from './ClientAllowancesTable.scss';

const newAllowanceUrl = payrollGroupId =>
  concatParamsToUrl(CLIENT_ALLOWANCE_NEW, { payrollRulesGroupId: payrollGroupId });
const unitPricesListUrl = payrollRulesGroupId => concatParamsToUrl(CLIENT_UNIT_PRICES_LIST, { payrollRulesGroupId });
const changeDisplayOrderUrl = payrollRulesGroupId =>
  concatParamsToUrl(CLIENT_ALLOWANCE_CHANGE_DISPLAY_ORDERS, { payrollRulesGroupId });

const SelectAllowanceType = ({ allowanceTypes, selectedAllowanceType, handleOnClick }) => (
  <div className={styles.filter}>
    {allowanceTypes.map(allowanceType => (
      <Tag
        key={allowanceType.value}
        active={allowanceType.value === selectedAllowanceType}
        onClick={e => {
          e.preventDefault();
          handleOnClick(allowanceType);
        }}
      >
        {allowanceType.label}
      </Tag>
    ))}
  </div>
);

class ClientAllowancesTable extends React.Component {
  constructor(props) {
    super(props);

    this.handleOnSelectAllowanceType = this.handleOnSelectAllowanceType.bind(this);
    this.handleDeleteRow = this.handleDeleteRow.bind(this);

    this.state = {
      allAllowances: this.props.allowances,
      selectedAllowanceType: 'payment'
    };
  }

  getDisplayAllowances() {
    return this.state.allAllowances.filter(item => item.allowanceType === this.state.selectedAllowanceType);
  }

  handleOnSelectAllowanceType(allowanceType) {
    this.setState({
      ...this.state,
      selectedAllowanceType: allowanceType.value
    });
  }

  handleDeleteRow(allowance) {
    deleteAllowance(allowance.clientPayrollRulesGroupId, allowance.id)
      .then(() => {
        this.props.displaySuccesses('支給・控除項目を削除しました。');
        this.setState({
          allAllowances: this.state.allAllowances.filter(item => item.id !== allowance.id)
        });
      })
      .catch(exception => {
        this.props.displayErrors(exception.response.data.errors.messages);
      });
  }

  render() {
    const { allowanceTypes, payrollRulesGroup } = this.props;
    const payrollRulesGroupId = payrollRulesGroup.id;

    return (
      <div>
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">{this.props.t('features.ClientAllowances.components.ClientAllowancesTable.provision_deduction_items_list')}</h1>
          <div className="m-title-main-note">{payrollRulesGroup.name}</div>
        </div>
        <div className="l-wrap-s l-contents-wrap">
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label={this.props.t('features.ClientAllowances.components.ClientAllowancesTable.setting')} path={CLIENT_SETTINGS} />
              <BreadCrumb.Item label={this.props.t('features.ClientAllowances.components.ClientAllowancesTable.salary_rule_group_list')} path={CLIENT_PAYROLL_RULES_GROUP_LIST} />
              <BreadCrumb.Item label={this.props.t('features.ClientAllowances.components.ClientAllowancesTable.provision_deduction_items_list')} />
            </BreadCrumb>
          </div>
          <div className={styles.head}>
            <div>
              <SelectAllowanceType
                allowanceTypes={allowanceTypes}
                selectedAllowanceType={this.state.selectedAllowanceType}
                handleOnClick={this.handleOnSelectAllowanceType}
              />
            </div>
            <div>
              <ActionButton as="a" href={newAllowanceUrl(payrollRulesGroupId)} icon={<Plus size={10} />}>
                {this.props.t('features.ClientAllowances.components.ClientAllowancesTable.add_item')}
              </ActionButton>
              <ActionButton
                as="a"
                href={changeDisplayOrderUrl(payrollRulesGroupId)}
                className="u-ml10"
                icon={<Drugging size={10} />}
              >
                {this.props.t('features.ClientAllowances.components.ClientAllowancesTable.rearrange_items')}
              </ActionButton>
              <ActionButton as="a" href={unitPricesListUrl(payrollRulesGroupId)} className="u-ml10">
                {this.props.t('features.ClientAllowances.components.ClientAllowancesTable.unit_price_setting')}
              </ActionButton>
            </div>
          </div>
          <AllowancesTable allowances={this.getDisplayAllowances()} handleDeleteRow={this.handleDeleteRow} />
        </div>
      </div>
    );
  }
}

export default withTranslation()(connect(
  state => ({
    allowanceTypes: getRadioOptions(state, 'allowanceTypes'),
    allowances: getList(REDUCER_NAME, state)
  }),
  dispatch => ({
    displayErrors: msg => dispatch(setGlobalErrors(msg)),
    displaySuccesses: msg => dispatch(setGlobalSuccesses(msg))
  })
)(ClientAllowancesTable));
